import * as React from "react";
import SummaryGauge from "../SummaryGauge/SummaryGauge";
import TankComponent from "../TankComponent/TankComponent";
import StatSection from "../StatSection/StatSection";
import TankOrigin from "../TankOrigin/TankOrigin";
import TechTree from "../TechTree/TechTree";
import TankSidebar from "../TankSidebar/TankSidebar";
import ModuleSection from "../ModuleCustomization/ModuleSection";
import { getTankStats } from "../../helpers/summaryStat";

const STRINGS = {
    INCOMPATIBILITY_WARNING: gettext("Selected gun module is incompatible with turret module"),
};

export class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            turrets: {
                value: 0,
                newValue: 0
            },
            chassis: {
                value: 0,
                newValue: 0
            },
            radios: {
                value: 0,
                newValue: 0
            },
            engines: {
                value: 0,
                newValue: 0
            },
            guns: {
                value: 0,
                newValue: 0
            },
        };
        this.setPackageSelect = this.setPackageSelect.bind(this);
        this.handleReset = this.handleReset.bind(this);
    };

    setPackageSelect = (val, tank_module) => {
        this.setState({
            [tank_module]: {
                value: val,
                newValue: val
            }
        })
    };

    setNewPackage = (val, tank_module) => {
        this.setState({
            [tank_module]: {
                value: this.state[tank_module].value,
                newValue: val
            }
        })
    };

    removeNewPackage = (val, tank_module) => {
        this.setState({
            [tank_module]: {
                value: this.state[tank_module].value,
                newValue: this.state[tank_module].value,
            }
        })
    };

    renderWarning = () => {
        let selectedGunIndex = this.state.guns.value;
        let selectedGunName = vehicle.unlock_progression.guns[selectedGunIndex].name;

        let selectedTurretIndex = this.state.turrets.value;
        let gunsCompatibleWithSelectedTurret = vehicle.unlock_progression.turrets[selectedTurretIndex].gun_names;

        if (!gunsCompatibleWithSelectedTurret.includes(selectedGunName)) {
            return (
                <div className="tank-stat_warning">
                    <span>
                        <img className="tank-config_ico" src={STATIC_URL + "portal/css/scss/tank-page/img/warning.svg"} />
                        {STRINGS.INCOMPATIBILITY_WARNING}
                    </span>
                </div>
            )
        } else {
            return null;
        }
    };

    handleReset = () => {
        this.setState({
            turrets: {
                value: 0,
                newValue: 0
            },
            chassis: {
                value: 0,
                newValue: 0
            },
            radios: {
                value: 0,
                newValue: 0
            },
            engines: {
                value: 0,
                newValue: 0
            },
            guns: {
                value: 0,
                newValue: 0
            },
        })
    };

    render() {

        const vehicle_titles = {
            MATCHMAKING: gettext("Matchmaking"),
            PACKAGE_SELECTOR: gettext("Select Package"),
            VEHICLE_SUMMARY: gettext("Vehicle Summary"),
            CURRENT_CONFIGURATION: gettext("Current Configuration"),
            KEY_STATISTICS: gettext("Key Statistics"),
            MODULE_CUSTOMIZATION: gettext("Module Customization"),
            MODULE_DETAILS: gettext("Module Details"),
        };
        const stat_titles = {
            PENETRATION: gettext("Penetration"),
            DAMAGE: gettext("Damage"),
            HIT_POINTS: gettext("Hit Points"),
            MAX_SPEED: gettext("Max Speed"),
            VISION_RANGE: gettext("Vision Range"),
            MOVING_STILL_DETECT_RANGE: gettext("Detectability Range"),
        };
        const config_titles = {
            TURRET: gettext("turret"),
            GUN: gettext("gun"),
            ENGINE: gettext("engine"),
            TREADS: gettext("treads"),
            RADIO: gettext("radio"),
            CHASSIS: gettext("suspension"),
        };

        const mode_subtitle = {
            SIEGE: gettext('* Vehicle stats include values for Siege mode.'),
            RAPID: gettext('* Vehicle stats include values for Rapid mode.'),
            TURBO: gettext('* Vehicle stats include values for Turbo mode.'),
        };

        const module_titles = {
            MODULE_CUSTOMIZATION: gettext("Module Customization"),
            SELECT_MULTI_MODULES: gettext("Select Multiple Modules"),
            RESET_TO_STOCK: gettext("Reset to stock"),
            INCOMPATIBILITY_WARNING: gettext("Selected gun module is incompatible with turret module"),
        };

        const treeStrokeColor = "#b5b598";

        let tankStats = getTankStats(this.state);
        let configurationComponents = tankStats.configuration,
            gaugeComponents = tankStats.stat;
        let multigunEnabled = vehicle.info.tags.includes("wotx_multiWeapon");

        return (
            <div>
                <section className="tank-stat">
                    <div className="tank-page_slant-bar">
                        <div className="tank-page_slant-bar_left"></div>
                        <div className="tank-page_slant-bar_middle"></div>
                        <div className="tank-page_slant-bar_right"></div>
                    </div>
                    <div className="tank-stat_wrapper">
                        <div className="tank-stat_column-left">
                            <TankSidebar />
                        </div>

                        <div className="tank-stat_column-right">
                            <div className="tank-stat__statistics">
                                <div className="tank-stat_title banner">
                                    <h3 className="tank-stat_title banner_middle_header tankopedia-detail">{vehicle_titles.KEY_STATISTICS}</h3>
                                </div>
                                <div className="tank-stat_body key-statistic">
                                    <StatSection title={stat_titles.PENETRATION}
                                        icon="attack"
                                        componentData={gaugeComponents.piercing_power} />
                                    <StatSection title={stat_titles.DAMAGE}
                                        icon="attack"
                                        componentData={gaugeComponents.damage} />
                                    <StatSection title={stat_titles.HIT_POINTS}
                                        icon="health"
                                        componentData={gaugeComponents.hit_points} />
                                    <StatSection title={stat_titles.MAX_SPEED}
                                        icon="speed"
                                        componentData={gaugeComponents.max_speed} />
                                    <StatSection title={stat_titles.VISION_RANGE}
                                        icon="range"
                                        componentData={gaugeComponents.vision_range} />
                                    <StatSection title={stat_titles.MOVING_STILL_DETECT_RANGE}
                                        icon="concealment"
                                        componentData={gaugeComponents.moving_still_detect_range} />
                                </div>
                            </div>
                            <div className="tank-stat__statistics">
                                <div className="tank-stat_title banner">
                                    <h3 className="tank-stat_title banner_middle_header tankopedia-detail">{module_titles.MODULE_CUSTOMIZATION}</h3>
                                </div>
                                <div className="tank-stat_title select-module">
                                    <h3 className="tank-stat_title select-module_multiple">{module_titles.SELECT_MULTI_MODULES}</h3>
                                    <h3 className="tank-stat_title select-module_reset" onClick={this.handleReset}>{module_titles.RESET_TO_STOCK}</h3>
                                </div>
                                <div className="tank-stat_body module_selection">
                                    <ModuleSection
                                        title={config_titles.GUN}
                                        key={"guns"}
                                        icon={"module_gun_level_0"}
                                        componentData={vehicle.unlock_progression["guns"]}
                                        configurationComponents={configurationComponents["gun"]}
                                        config_title={config_titles.GUN}
                                        tank_module={"guns"}
                                        currentGunIndex={this.state.guns.value}
                                        currentTurrentIndex={this.state.turrets.value}
                                        currentComponentIndex={this.state.guns.value}
                                        setPackageSelect={this.setPackageSelect}
                                        setNewPackage={this.setNewPackage}
                                        removeNewPackage={this.removeNewPackage}
                                        multigunEnabled={multigunEnabled}
                                    />
                                    <ModuleSection
                                        title={config_titles.TURRET}
                                        key={"turrets"}
                                        icon={"module_turret_level_0"}
                                        componentData={vehicle.unlock_progression["turrets"]}
                                        configurationComponents={configurationComponents["turret"]}
                                        config_title={config_titles.TURRET}
                                        tank_module={"turrets"}
                                        currentGunIndex={this.state.guns.value}
                                        currentTurrentIndex={this.state.turrets.value}
                                        currentComponentIndex={this.state.turrets.value}
                                        setPackageSelect={this.setPackageSelect}
                                        setNewPackage={this.setNewPackage}
                                        removeNewPackage={this.removeNewPackage}
                                    />
                                    <ModuleSection
                                        title={config_titles.ENGINE}
                                        key={"engines"}
                                        icon={"module_engine_level_0"}
                                        componentData={vehicle.unlock_progression["engines"]}
                                        configurationComponents={configurationComponents["engine"]}
                                        config_title={config_titles.ENGINE}
                                        tank_module={"engines"}
                                        currentGunIndex={this.state.guns.value}
                                        currentTurrentIndex={this.state.turrets.value}
                                        currentComponentIndex={this.state.engines.value}
                                        setPackageSelect={this.setPackageSelect}
                                        setNewPackage={this.setNewPackage}
                                        removeNewPackage={this.removeNewPackage}
                                    />
                                    <ModuleSection
                                        title={config_titles.CHASSIS}
                                        key={"chassis"}
                                        icon={"module_suspension_level_0"}
                                        componentData={vehicle.unlock_progression["chassis"]}
                                        configurationComponents={configurationComponents["chassis"]}
                                        config_title={config_titles.CHASSIS}
                                        tank_module={"chassis"}
                                        currentGunIndex={this.state.guns.value}
                                        currentTurrentIndex={this.state.turrets.value}
                                        currentComponentIndex={this.state.chassis.value}
                                        setPackageSelect={this.setPackageSelect}
                                        setNewPackage={this.setNewPackage}
                                        removeNewPackage={this.removeNewPackage}
                                    />
                                    <ModuleSection
                                        title={config_titles.RADIO}
                                        key={"radios"}
                                        icon={"module_radio_level_0"}
                                        componentData={vehicle.unlock_progression["radios"]}
                                        configurationComponents={configurationComponents["radio"]}
                                        config_title={config_titles.RADIO}
                                        tank_module={"radios"}
                                        currentGunIndex={this.state.guns.value}
                                        currentTurrentIndex={this.state.turrets.value}
                                        currentComponentIndex={this.state.radios.value}
                                        setPackageSelect={this.setPackageSelect}
                                        setNewPackage={this.setNewPackage}
                                        removeNewPackage={this.removeNewPackage}
                                    />
                                </div>
                            </div>
                            <div className="tank-stat__configuration">
                                <div className="tank-stat_warning-container">
                                    {this.renderWarning()}
                                </div>
                                <div className="tank-stat_title module-details-header">
                                    <h3>{vehicle_titles.MODULE_DETAILS}</h3>
                                </div>
                                <div className="tank-stat_body">

                                    <TankComponent type={config_titles["gun"]}
                                        icon={"gun"}
                                        currentIndex={this.state.guns.value}
                                        componentData={configurationComponents["gun"]}
                                        key={"guns"}
                                        tank_module={"guns"}
                                    />
                                    <TankComponent type={config_titles["turret"]}
                                        icon={"turret"}
                                        currentIndex={this.state.turrets.value}
                                        componentData={configurationComponents["turret"]}
                                        key={"turrets"}
                                        tank_module={"turrets"}
                                    />
                                    <TankComponent type={config_titles["engine"]}
                                        icon={"engine"}
                                        currentIndex={this.state.engines.value}
                                        componentData={configurationComponents["engine"]}
                                        key={"engines"}
                                        tank_module={"engines"}
                                    />
                                    <TankComponent type={config_titles["chassis"]}
                                        icon={"track"}
                                        currentIndex={this.state.chassis.value}
                                        componentData={configurationComponents["chassis"]}
                                        key={"chassis"}
                                        tank_module={"chassis"}
                                    />
                                    <TankComponent type={config_titles["radio"]}
                                        icon={"radio"}
                                        currentIndex={this.state.radios.value}
                                        componentData={configurationComponents["radio"]}
                                        key={"radios"}
                                        tank_module={"radios"}
                                    />
                                </div>
                                <div className="tank-stat_subtitle">
                                    {(vehicle.info.tags.includes('siegeMode') && !(vehicle.info.tags.includes('wotx_wheeled')) && !(vehicle.info.tags.includes('turboshaftEngine'))) && !multigunEnabled ? mode_subtitle.SIEGE : null}
                                    {vehicle.info.tags.includes('wotx_wheeled') ? mode_subtitle.RAPID : null}
                                    {vehicle.info.tags.includes('turboshaftEngine') ? mode_subtitle.TURBO : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <TankOrigin description={vehicle.info.description} />
                {
                    (vehicle.tree.length !== 0) && <TechTree data={vehicle.tree} treeStrokeColor={treeStrokeColor} currentVehicle={vehicle.info} />
                }
            </div>
        );
    }
}
